<script>
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";

export default {
  name: "PropertyCreate",
  components: {
    DatePicker,
    MaskedInput,
  },
  data() {
    return {
      submitted: false,
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      percentMask: createNumberMask({
        prefix: "",
        suffix: "%",
        allowDecimal: true,
        integerLimit: 2,
        includeThousandsSeparator: false
      }),
      modalTitle: "",
      form: {
        id: null,
        name: "",
        brand: "",
        model: "",
        specification: "",
        color: "",
        dimensionDescription: "",
        materialUsed: "",
        packageDescription: "",
        propertyNumber: "",
        serialNumber: "",
        dateAcquired: "",
        warrantyStartDate: "",
        warrantyEndDate: "",
        amount: "",
        lifespanInYears: "",
        yearlyDepreciation: "",
        salvageValue: "",
        itemCategoryId: "",
        supplierId: 0,
        supplier: "",
        poNumber: "",
        note: "",
        condition: "",
        fundCluster: "",
        fundClusterId: "",
        fundClusterName: "",
        unit: "",
        isDonated: false,
        parentPropertyId: 0,
        propertyAssignments: [
          {
            propertyId: 0,
            employeeIdNumber: "",
            propertyLocationId: 0,
            assignNotes: null,
            assignmentType: null,
            assignmentNumber: null,
            dateAssigned: null,
            renewalDate: null
          }
        ]
      },
      poIndex: -1,
      propertyIndex: -1,
      fundClusterId: "",
      itemCategory: "",
      employeeName: "",
      location: "",
      campusId: this.$store.state.data.selectedCampus.id,
    };
  },
  validations: {
    form: {
      name: { required },
      poNumber: { required },
      propertyNumber: { required },
      amount: { required },
      lifespanInYears: { required },
      yearlyDepreciation: { required },
      salvageValue: { required },
      itemCategoryId: { required },
      fundClusterId: { required },
      supplier: { required },
      condition: { required },
      unit: { required }
    }
  },
  methods: {
    createProperty() {
      this.onReset();
      this.modalTitle = "Create Property";
      this.$bvModal.show("modal-property-create");
    },
    updateProperty(propertyId) {
      this.onReset();
      this.$store
        .dispatch("property/GetSingleProperty", propertyId)
        .then((res) => {
          var data = cloneDeep(res.data);
          this.form = data;
          this.form.dateAcquired = !data.dateAcquired.includes("0001-01-01")
            ? new Date(data.dateAcquired)
            : "";
          this.form.warrantyStartDate = !data.warrantyStartDate.includes(
            "0001-01-01"
          )
            ? new Date(data.warrantyStartDate)
            : "";
          this.form.warrantyEndDate = !data.warrantyEndDate.includes(
            "0001-01-01"
          )
            ? new Date(data.warrantyEndDate)
            : "";
          this.form.lifespanInYears = data.lifespanInYears.toString();
          this.form.amount = data.amount.toString();
          this.form.salvageValue = data.salvageValue.toString();
          this.calculateYearlyDepreciation();
          this.form.yearlyDepreciation = this.form.yearlyDepreciation.toString();
          this.itemCategory = data.itemCategory.name;
          this.fundClusterId = data.cluster ? data.cluster.cluster : "";
          this.modalTitle = "Update Property";
          this.$bvModal.show("modal-property-create");
        })
        .catch(() => {
          this.showToast(
            "Something went wrong - Getting property details!",
            "error"
          );
        });
    },
    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.checkForm() || this.$v.$invalid) {
        this.showPermanentToast(
          "There are fields that require your attention.",
          "error"
        );
        return;
      } else {
        try {
          var data = cloneDeep(this.form);
          data.campusId = this.campusId;
          data.dateAcquired =
            data.dateAcquired != "" && data.dateAcquired != null
              ? this.getDate(data.dateAcquired)
              : "0001-01-01T00:00:00";
          data.warrantyStartDate =
            data.warrantyStartDate != "" && data.warrantyStartDate != null
              ? this.getDate(data.warrantyStartDate)
              : "0001-01-01T00:00:00";
          data.warrantyEndDate =
            data.warrantyEndDate != "" && data.warrantyEndDate != null
              ? this.getDate(data.warrantyEndDate)
              : "0001-01-01T00:00:00";
          data.poNumber = data.poNumber.trim();
          data.propertyNumber = data.propertyNumber.trim();
          data.name = data.name.trim();
          data.amount = this.getExactAmt(data.amount);
          data.yearlyDepreciation = this.getExactAmt(data.yearlyDepreciation);
          data.salvageValue = this.setPercent(data.salvageValue);
          if (data.id > 0) {
            this.$store
              .dispatch("property/UpdateProperty", data)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                this.showToast("Successfully updated!", "success");
                this.$bvModal.hide("modal-property-create");
                this.$emit("updateData", res.data);
              })
              .catch((err) => {
                this.showToast(
                  "Something went wrong - Updating this property!",
                  "error"
                );
              });
          } else {
            data.iarItemId = 0;
            data.requisitionItemId = 0;
            if (
              data.propertyAssignments[0].employeeIdNumber != null &&
              data.propertyAssignments[0].employeeIdNumber != ""
            ) {
              data.propertyAssignments[0].dateAssigned = this.getDate(
                data.propertyAssignments[0].dateAssigned
              );
              data.propertyAssignments[0].renewalDate = this.getDate(
                data.propertyAssignments[0].renewalDate
              );
            } else data.propertyAssignments = [];
            this.$store
              .dispatch("property/CreateProperty", data)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                this.showToast("Successfully created!", "success");
                this.$bvModal.hide("modal-property-create");
                this.$emit("createData", res.data);
              })
              .catch((err) => {
                this.showToast(
                  "Something went wrong - Creating property!",
                  "error"
                );
              });
          }
          this.submitted = false;
        } catch (error) {
          this.showToast("Something went wrong!", "error");
        }
      }
    },
    checkForm() {
      let checkId = 0;
      if (this.form.itemCategoryId == 0) {
        this.form.itemCategoryId = "";
        checkId++;
      }
      if (this.form.fundClusterId == 0) {
        this.form.fundClusterId = "";
        checkId++;
      }
      if (this.form.unit == 0) {
        this.form.unit = "";
        checkId++;
      }
      if (
        this.form.warrantyStartDate != "" &&
        this.form.warrantyStartDate != null &&
        (this.form.warrantyEndDate == "" || this.form.warrantyEndDate == null)
      ) {
        checkId++;
      }
      if (
        this.form.warrantyEndDate != "" &&
        this.form.warrantyEndDate != null &&
        (this.form.warrantyStartDate == "" ||
          this.form.warrantyStartDate == null)
      ) {
        checkId++;
      }
      if (checkId > 0) {
        return true;
      } else if (!this.form.id) {
        if (
          this.form.propertyAssignments[0].employeeIdNumber != null &&
          this.form.propertyAssignments[0].employeeIdNumber != "" &&
          (this.form.propertyAssignments[0].propertyLocationId == "" ||
            this.form.propertyAssignments[0].propertyLocationId == null ||
            this.form.propertyAssignments[0].propertyLocationId == 0 ||
            this.form.propertyAssignments[0].assignmentType == "" ||
            this.form.propertyAssignments[0].assignmentType == null ||
            this.form.propertyAssignments[0].dateAssigned == "" ||
            this.form.propertyAssignments[0].dateAssigned == null ||
            this.form.propertyAssignments[0].renewalDate == "" ||
            this.form.propertyAssignments[0].renewalDate == null ||
            this.form.propertyAssignments[0].assignmentNumber == "" ||
            this.form.propertyAssignments[0].assignmentNumber == null)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getFundCluster() {
      this.$emit("getFundCluster", "create-modal");
    },
    dropFundCluster(data) {
      this.form.fundClusterId = data.id;
      this.fundClusterId = data.cluster;
    },
    getItemCategory() {
      this.$emit("getItemCategory", "create-modal");
    },
    dropItemCat(data) {
      this.form.itemCategoryId = data.id;
      this.itemCategory = data.name;
    },
    getSupplier() {
      this.$emit("getSupplier", "create-modal");
    },
    dropSupplier(data) {
      this.form.supplierId = data.id;
      this.form.supplier = data.name;
    },
    removeSupplier() {
      this.form.supplierId = 0;
      this.form.supplier = "";
    },
    getUnit() {
      this.$emit("getUnit", "create-modal");
    },
    dropUnit(data) {
      this.form.unit = data.unitName;
    },
    getEmployee() {
      this.$emit("getEmployee", "create-modal");
    },
    dropEmployee(data) {
      var firstname = data.firstName;
      var lastname = data.lastName;
      this.form.propertyAssignments[0].employeeIdNumber = data.idNo;
      this.employeeName = firstname.concat(" ", lastname);
    },
    getLocation() {
      this.$emit("getLocation", "create-modal");
    },
    dropLocation(data) {
      this.form.propertyAssignments[0].propertyLocationId = data.location.id;
      this.location = data.location.location;
    },
    calculateYearlyDepreciation() {
      if (
        this.form.amount == null ||
        this.form.amount == "" ||
        this.form.lifespanInYears == null ||
        this.form.lifespanInYears == "" ||
        this.form.salvageValue == null ||
        this.form.salvageValue == ""
      ) {
        this.form.yearlyDepreciation = null;
        this.$forceUpdate();
      } else if (
        this.form.amount == 0 ||
        this.form.lifespanInYears == 0 ||
        this.form.dateAcquired == null ||
        this.form.dateAcquired == ""
      ) {
        this.form.yearlyDepreciation = "0";
        this.$forceUpdate();
      } else {
        var value =
          (parseFloat(this.getExactAmt(this.form.amount)) -
            (parseFloat(this.setPercent(this.form.salvageValue)) / 100) *
            parseFloat(this.getExactAmt(this.form.amount))) /
          parseFloat(this.getExactAmt(this.form.lifespanInYears));
        this.form.yearlyDepreciation = value
          ? value.toFixed(2).toString()
          : null;
        this.$forceUpdate();
      }
    },
    setPercent(percent) {
      if (percent.includes("%")) {
        return percent.substring(0, percent.length - 1);
      } else return percent;
    },
    disabledRangeFrom(date) {
      if (this.form.warrantyEndDate != "")
        return date > new Date(this.form.warrantyEndDate);
    },
    disabledRangeTo(date) {
      if (this.form.warrantyStartDate != "")
        return date < new Date(this.form.warrantyStartDate);
    },
    onReset() {
      this.form = {
        id: null,
        name: "",
        specification: "",
        color: "",
        dimensionDescription: "",
        materialUsed: "",
        packageDescription: "",
        propertyNumber: "",
        serialNumber: "",
        dateAcquired: "",
        warrantyStartDate: "",
        warrantyEndDate: "",
        amount: "",
        lifespanInYears: "",
        yearlyDepreciation: "",
        salvageValue: "",
        itemCategoryId: "",
        supplierId: 0,
        supplier: "",
        poNumber: "",
        note: "",
        condition: "New",
        fundCluster: "",
        fundClusterId: "",
        unit: "",
        isDonated: false,
        parentPropertyId: 0,
        propertyAssignments: [
          {
            propertyId: 0,
            employeeIdNumber: "",
            propertyLocationId: 0,
            assignNotes: "",
            assignmentType: "",
            assignmentNumber: "",
            dateAssigned: "",
            renewalDate: ""
          }
        ]
      };
      this.fundClusterId = "";
      this.itemCategory = "";
      this.employeeName = "";
      this.location = "";
      this.submitted = false;
    }
  },
};
</script>

<template>
  <div>
    <b-modal id="modal-property-create" :title="modalTitle" size="xl" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <form @submit.prevent="onCreate" class="needs-validation mt-3" ref="fcForm">
        <div class="ms-3 me-3">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="poNumber">P.O. Number </label>
                <input id="poNumber" type="text" v-model="form.poNumber" placeholder="Enter PO Number..."
                  class="form-control" :class="{
                    'is-invalid': submitted && $v.form.poNumber.$error
                  }" autocomplete="off" />
                <div v-if="submitted && $v.form.poNumber.$error" class="invalid-feedback">
                  <span v-if="!$v.form.poNumber.required">This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="propertyNumber">Property Number </label>
                <input id="propertyNumber" type="text" v-model="form.propertyNumber"
                  placeholder="Enter Property Number..." class="form-control" :class="{
                    'is-invalid': submitted && $v.form.propertyNumber.$error
                  }" autocomplete="off" />
                <div v-if="submitted && $v.form.propertyNumber.$error" class="invalid-feedback">
                  <span v-if="!$v.form.propertyNumber.required">This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="propertyName">Property Name </label>
                <input id="propertyName" type="text" v-model="form.name" placeholder="Enter Property Name..."
                  class="form-control" :class="{
                    'is-invalid': submitted && $v.form.name.$error
                  }" autocomplete="off" />
                <div v-if="submitted && $v.form.name.$error" class="invalid-feedback">
                  <span v-if="!$v.form.name.required">This value is required.</span>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="dateAcquired">Date Acquired </label>
                  <date-picker v-model="form.dateAcquired" :first-day-of-week="1" lang="en"
                    placeholder="Enter Date Acquired..." @change="calculateYearlyDepreciation()"></date-picker>
                </div>
                <div class="col-md-6">
                  <label for="amount">Amount </label>
                  <masked-input id="amount" type="text" v-model="form.amount" placeholder="Enter Amount..."
                    class="form-control" :class="{
                      'is-invalid': submitted && $v.form.amount.$error
                    }" autocomplete="off" :mask="currencyMask" @input="calculateYearlyDepreciation()"></masked-input>
                  <div v-if="submitted && $v.form.amount.$error" class="invalid-feedback">
                    <span v-if="!$v.form.amount.required">This value is required.</span>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4">
                  <label for="salvageValue">Scrap Value </label>
                  <masked-input id="salvageValue" type="text" v-model="form.salvageValue"
                    placeholder="Enter Scrap Value..." class="form-control" :class="{
                      'is-invalid': submitted && $v.form.salvageValue.$error
                    }" autocomplete="off" :mask="percentMask" @input="calculateYearlyDepreciation()"></masked-input>
                  <div v-if="submitted && $v.form.salvageValue.$error" class="invalid-feedback">
                    <span v-if="!$v.form.salvageValue.required">This value is required.</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="lifespanInYears">Life Span in Years </label>
                  <masked-input id="lifespanInYears" type="text" v-model="form.lifespanInYears"
                    placeholder="Enter Life Span..." class="form-control" :class="{
                      'is-invalid': submitted && $v.form.lifespanInYears.$error
                    }" autocomplete="off" :mask="quantityMask" @input="calculateYearlyDepreciation()"></masked-input>
                  <div v-if="submitted && $v.form.lifespanInYears.$error" class="invalid-feedback">
                    <span v-if="!$v.form.lifespanInYears.required">This value is required.</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="yearlyDepreciation">Yearly Depreciation </label>
                  <masked-input id="yearlyDepreciation" type="text" v-model="form.yearlyDepreciation"
                    placeholder="Calculating..." class="form-control" :class="{
                      'is-invalid':
                        submitted && $v.form.yearlyDepreciation.$error
                    }" autocomplete="off" disabled :mask="currencyMask"></masked-input>
                  <div v-if="submitted && $v.form.yearlyDepreciation.$error" class="invalid-feedback">
                    <span v-if="!$v.form.yearlyDepreciation.required">This value is required.</span>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="dateExpected">Warranty Date </label>
                <div class="row">
                  <div class="col-6">
                    <date-picker v-model="form.warrantyStartDate" :first-day-of-week="1" lang="en"
                      @Change="$forceUpdate()" :disabled-date="disabledRangeFrom" placeholder="Enter Warranty Start..."
                      :class="{
                        'is-invalid':
                          submitted &&
                          ((form.warrantyStartDate != '' &&
                            form.warrantyStartDate != null &&
                            (form.warrantyEndDate === '' ||
                              form.warrantyEndDate === null)) ||
                            (form.warrantyEndDate != '' &&
                              form.warrantyEndDate != null &&
                              (form.warrantyStartDate === '' ||
                                form.warrantyStartDate === null)))
                      }"></date-picker>
                  </div>
                  <div class="col-6">
                    <date-picker v-model="form.warrantyEndDate" :first-day-of-week="1" lang="en"
                      @Change="$forceUpdate()" :disabled-date="disabledRangeTo" placeholder="Enter Warranty End..."
                      :class="{
                        'is-invalid':
                          submitted &&
                          ((form.warrantyStartDate != '' &&
                            form.warrantyStartDate != null &&
                            (form.warrantyEndDate === '' ||
                              form.warrantyEndDate === null)) ||
                            (form.warrantyEndDate != '' &&
                              form.warrantyEndDate != null &&
                              (form.warrantyStartDate === '' ||
                                form.warrantyStartDate === null)))
                      }"></date-picker>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="brand">Brand </label>
                <input id="brand" type="text" v-model="form.brand" placeholder="Enter Brand..." class="form-control"
                  autocomplete="off" />
              </div>
              <div class="mb-3">
                <label for="condition">Property Condition </label>
                <b-form-select class="form-select" :class="{
                  'is-invalid': submitted && $v.form.condition.$error
                }" v-model="form.condition">
                  <b-form-select-option value="" disabled>Select Condition...</b-form-select-option>
                  <b-form-select-option value="New">New</b-form-select-option>
                  <b-form-select-option value="Purchased">Purchased</b-form-select-option>
                  <b-form-select-option value="Used">Used</b-form-select-option>
                  <b-form-select-option value="Donated">Donated</b-form-select-option>
                  <b-form-select-option value="Refurbished">Refurbished</b-form-select-option>
                  <b-form-select-option value="Re-condition">Re-condition</b-form-select-option>
                </b-form-select>
                <div v-if="submitted && $v.form.condition.$error" class="invalid-feedback">
                  <span v-if="!$v.form.condition.required">This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="specification">Property Specification </label>
                <textarea id="specification" rows="2" v-model="form.specification"
                  placeholder="Enter Property Specification..." class="form-control" autocomplete="off"></textarea>
              </div>
              <div class="mb-3">
                <label for="color">Color </label>
                <input id="color" type="text" v-model="form.color" placeholder="Enter Property Color..."
                  class="form-control" autocomplete="off" />
              </div>
              <div class="mb-3">
                <label for="dimensionDescription">Dimension Description </label>
                <input id="dimensionDescription" type="text" v-model="form.dimensionDescription"
                  placeholder="Enter Dimension Description..." class="form-control" autocomplete="off" />
              </div>
              <div class="mb-3">
                <div class="form-check form-checkbox-outline form-check-success mb-0">
                    <input
                        type="checkbox"
                        id="isDonated"
                        class="form-check-input"
                        v-model="form.isDonated"
                    />
                  <label for="isDonated" class="form-check-label">Is Donated?</label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fundCluster">Fund Source </label>
                <input id="fundCluster" type="text" v-model="form.fundCluster" placeholder="Enter Fund Source..."
                  class="form-control" autocomplete="off" />
              </div>
              <div class="mb-3">
                <label for="fundClusterId">Fund Cluster </label>
                <b-input-group>
                  <template #append>
                    <b-button @click="getFundCluster()" variant="outline-info"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" disabled placeholder="Search Fund Cluster..."
                    class="form-control" :class="{
                      'is-invalid': submitted && $v.form.fundClusterId.$error
                    }" v-model="fundClusterId" />
                </b-input-group>
                <div v-if="submitted && $v.form.fundClusterId.$error" class="invalid-feedback">
                  <span v-if="!$v.form.fundClusterId.required">This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="serialNumber">Serial Number </label>
                <input id="serialNumber" type="text" v-model="form.serialNumber" placeholder="Enter Serial Number..."
                  class="form-control" autocomplete="off" />
              </div>
              <div class="mb-3">
                <label for="supplier">Supplier </label>
                <b-input-group>
                  <template #append>
                    <b-button @click="getSupplier" variant="outline-info" title="Search Supplier"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                    <b-button @click="removeSupplier" variant="outline-danger" title="Remove Supplier"><i
                        class="mdi mdi-close-thick"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" placeholder="Search/Enter Supplier..." class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.form.supplier.$error
                    }" v-model="form.supplier" />
                </b-input-group>
                <div v-if="submitted && $v.form.supplier.$error" class="invalid-feedback">
                  <span v-if="!$v.form.supplier.required">This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="unit">Unit </label>
                <b-input-group>
                  <template #append>
                    <b-button @click="getUnit()" variant="outline-info"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" disabled placeholder="Search Unit..." class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.form.unit.$error
                    }" v-model="form.unit" />
                </b-input-group>
                <div v-if="submitted && $v.form.unit.$error" class="invalid-feedback">
                  <span v-if="!$v.form.unit.required">This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="itemCategoryId">Item Category </label>
                <b-input-group>
                  <template #append>
                    <b-button @click="getItemCategory" variant="outline-info"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" disabled placeholder="Search Item Category..."
                    class="form-control" :class="{
                      'is-invalid': submitted && $v.form.itemCategoryId.$error
                    }" v-model="itemCategory" />
                </b-input-group>
                <div v-if="submitted && $v.form.itemCategoryId.$error" class="invalid-feedback">
                  <span v-if="!$v.form.itemCategoryId.required">This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="model">Model </label>
                <input id="model" type="text" v-model="form.model" placeholder="Enter Model..." class="form-control"
                  autocomplete="off" />
              </div>
              <div class="mb-3">
                <label for="materialUsed">Material Used </label>
                <textarea id="materialUsed" rows="2" v-model="form.materialUsed" placeholder="Enter Material Used..."
                  class="form-control" autocomplete="off"></textarea>
              </div>
              <div class="mb-3">
                <label for="packageDescription">Package Description </label>
                <textarea id="packageDescription" rows="2" v-model="form.packageDescription"
                  placeholder="Enter Package Description..." class="form-control" autocomplete="off"></textarea>
              </div>
              <div class="mb-3">
                <label for="note">Notes </label>
                <textarea id="note" rows="4" v-model="form.note" placeholder="Enter Notes..." class="form-control"
                  autocomplete="off"></textarea>
              </div>
            </div>
          </div>

          <div v-if="!(form.id > 0)">
            <hr class="my-3" />
            <h5 class="mt-1 mb-3">Property Assignment (Optional)</h5>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="assignmentNumber">PAR/ICS Number </label>
                  <input id="assignmentNumber" type="text" v-model="form.propertyAssignments[0].assignmentNumber"
                    placeholder="Enter PAR/ICS Number..." class="form-control" :class="{
                      'is-invalid':
                        submitted &&
                        form.propertyAssignments[0].employeeIdNumber != null &&
                        form.propertyAssignments[0].employeeIdNumber != '' &&
                        (form.propertyAssignments[0].assignmentNumber == '' ||
                          form.propertyAssignments[0].assignmentNumber == null)
                    }" autocomplete="off" />
                  <div v-if="
                    submitted &&
                    form.propertyAssignments[0].employeeIdNumber != null &&
                    form.propertyAssignments[0].employeeIdNumber != '' &&
                    (form.propertyAssignments[0].assignmentNumber == '' ||
                      form.propertyAssignments[0].assignmentNumber == null)
                  " class="invalid-feedback">
                    <span>This value is required.</span>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="dateAssigned">Date Assigned</label>
                  <date-picker v-model="form.propertyAssignments[0].dateAssigned" :first-day-of-week="1" lang="en"
                    placeholder="Enter Date Assigned..." :class="{
                      'is-invalid':
                        submitted &&
                        form.propertyAssignments[0].employeeIdNumber != null &&
                        form.propertyAssignments[0].employeeIdNumber != '' &&
                        (form.propertyAssignments[0].dateAssigned == '' ||
                          form.propertyAssignments[0].dateAssigned == null)
                    }"></date-picker>
                  <div v-if="
                    submitted &&
                    form.propertyAssignments[0].employeeIdNumber != null &&
                    form.propertyAssignments[0].employeeIdNumber != '' &&
                    (form.propertyAssignments[0].dateAssigned == '' ||
                      form.propertyAssignments[0].dateAssigned == null)
                  " class="invalid-feedback">
                    <span>This value is required.</span>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="renewalDate">Renewal Date</label>
                  <date-picker v-model="form.propertyAssignments[0].renewalDate" :first-day-of-week="1" lang="en"
                    placeholder="Enter Renewal Date..." :class="{
                      'is-invalid':
                        submitted &&
                        form.propertyAssignments[0].employeeIdNumber != null &&
                        form.propertyAssignments[0].employeeIdNumber != '' &&
                        (form.propertyAssignments[0].renewalDate == '' ||
                          form.propertyAssignments[0].renewalDate == null)
                    }"></date-picker>
                  <div v-if="
                    submitted &&
                    form.propertyAssignments[0].employeeIdNumber != null &&
                    form.propertyAssignments[0].employeeIdNumber != '' &&
                    (form.propertyAssignments[0].renewalDate == '' ||
                      form.propertyAssignments[0].renewalDate == null)
                  " class="invalid-feedback">
                    <span>This value is required.</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="employee">Employee</label>
                  <b-input-group>
                    <template #append>
                      <b-button @click="getEmployee()" variant="outline-info"><i
                          class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                    </template>
                    <input autocomplete="off" type="text" disabled placeholder="Search Employee..." class="form-control"
                      v-model="employeeName" />
                  </b-input-group>
                </div>
                <div class="mb-3">
                  <label for="employee">Location</label>
                  <b-input-group>
                    <template #append>
                      <b-button @click="getLocation()" variant="outline-info"><i
                          class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                    </template>
                    <input autocomplete="off" type="text" disabled placeholder="Search Location..." class="form-control"
                      :class="{
                        'is-invalid':
                          submitted &&
                          form.propertyAssignments[0].employeeIdNumber > 0 &&
                          (form.propertyAssignments[0].propertyLocationId ==
                            '' ||
                            form.propertyAssignments[0].propertyLocationId ==
                            null)
                      }" v-model="location" />
                  </b-input-group>
                  <div v-if="
                    submitted &&
                    form.propertyAssignments[0].employeeIdNumber != null &&
                    form.propertyAssignments[0].employeeIdNumber != '' &&
                    (form.propertyAssignments[0].propertyLocationId == '' ||
                      form.propertyAssignments[0].propertyLocationId ==
                      null)
                  " class="invalid-feedback">
                    <span>This value is required.</span>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="assignmentType">Assignment Type </label>
                  <b-form-select class="form-select" :class="{
                    'is-invalid':
                      submitted &&
                      form.propertyAssignments[0].employeeIdNumber != null &&
                      form.propertyAssignments[0].employeeIdNumber != '' &&
                      (form.propertyAssignments[0].assignmentType == '' ||
                        form.propertyAssignments[0].assignmentType == null)
                  }" v-model="form.propertyAssignments[0].assignmentType">
                    <b-form-select-option value="" disabled>Select Type...</b-form-select-option>
                    <b-form-select-option value="New">New</b-form-select-option>
                    <b-form-select-option value="Donation">Donation</b-form-select-option>
                    <b-form-select-option value="Reassignment">Reassignment</b-form-select-option>
                    <b-form-select-option value="Relocate">Relocate</b-form-select-option>
                    <b-form-select-option value="Others">Others</b-form-select-option>
                  </b-form-select>
                  <div v-if="
                    submitted &&
                    form.propertyAssignments[0].employeeIdNumber != null &&
                    form.propertyAssignments[0].employeeIdNumber != '' &&
                    (form.propertyAssignments[0].assignmentType == '' ||
                      form.propertyAssignments[0].assignmentType == null)
                  " class="invalid-feedback">
                    <span>This value is required.</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label for="assignNotes">Notes </label>
              <textarea id="assignNotes" rows="3" v-model="form.propertyAssignments[0].assignNotes"
                placeholder="Enter Notes..." class="form-control" autocomplete="off"></textarea>
            </div>
          </div>

          <div class="d-flex flex-row-reverse mb-3">
            <button class="btn btn-primary mt-3" type="submit">
              {{
                !(form.id > 0) > 0 ? "Create New Property" : "Update Property"
              }}
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>